type FrequencyCounter = {
  [key: string]: number;
};

export function fequencyCounter<T extends Record<string, any>>(array: T[], keys: (keyof T)[]): FrequencyCounter {
  if (!array) return {};
  return array.reduce((acc, item) => {
    // Build a combined key from the specified keys
    const combinedKey = keys.map((key) => item[key] ?? 'null').join(' | ');
    acc[combinedKey] = (acc[combinedKey] || 0) + 1;
    return acc;
  }, {} as FrequencyCounter);
}
